import { render, staticRenderFns } from "./TheAsStampDescription.vue?vue&type=template&id=01dfbd43"
import script from "./TheAsStampDescription.vue?vue&type=script&lang=js"
export * from "./TheAsStampDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports